export default __webpack_public_path__ + "static/media/IMG_3068_6_11zon.dea820e0.jpg";